import { PRIVATE_URIS } from '../constants/privateURIs.constants';

/**
 * Single source of truth for links into the in-app User Manual (TRIL-424).
 * The section route is `PRIVATE_URIS.README_SECTION` (`/readme/:slug`); building
 * paths here (rather than hand-formatting strings at call sites) means a route
 * shape change lands in exactly one place.
 */
export const manualIndexPath = (): string => PRIVATE_URIS.README;

/**
 * Builds `/readme/<slug>`, optionally deep-linking to an in-page sub-section
 * (`/readme/<slug>#<sub>`), which the section page scrolls into view and
 * auto-expands on arrival.
 */
export function manualSectionPath(slug: string, sub?: string): string {
  const base = PRIVATE_URIS.README_SECTION.replace(':slug', slug);
  return sub ? `${base}#${sub}` : base;
}
